import { useState, useCallback } from 'react';
import { fetchWithCSRF } from '../utils/csrfUtils';
import { useAuth } from '../context/AuthContext';

const useGroceryListDifferences = () => {
    const [differences, setDifferences] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { sessionToken } = useAuth();

    const getDifferences = useCallback(async (groceryListId, appUserId, mealPlanId) => {
        setIsLoading(true);
        setError(null);
        try {
            if (!sessionToken) {
                throw new Error('No valid session found');
            }

            const response = await fetchWithCSRF(
                `${process.env.REACT_APP_POSTGRES_API_ENDPOINT}/grocery-list/differences/${groceryListId}/${appUserId}/${mealPlanId}`,
                { headers: { 'Authorization': `Bearer ${sessionToken}` } }
            );

            if (!response.ok) {
                throw new Error('Failed to fetch grocery list differences');
            }

            const data = await response.json();
            setDifferences(data);
            return data;
        } catch (err) {
            setError(err.message);
            console.error('Error fetching grocery list differences:', err);
            return [];
        } finally {
            setIsLoading(false);
        }
    }, [sessionToken]);

    return {
        differences,
        isLoading,
        error,
        getDifferences
    };
};

export default useGroceryListDifferences;
